import React, { Component } from 'react'
import Button from '../components/Button'
import { connect } from 'react-redux';
import { getFaqs } from '../actions/MainAction';
import Card from '../components/Card';
import { changeStateValue } from '../redux/MainReducer';
export class FaqPage extends Component {
    componentDidMount(){
        this.props.getFaqs();
    }
    editModalBtn=(data='')=>{
        this.props.changeStateValue({
            name:'modalData',
            value: {
              position: true,
              id: data?.id?data?.id:'',
              title: data?.title?data?.title:'',
              description: data?.description?data?.description:'',
              unrequire: ["unrequire", "funcParams", "id"],
              afterCallFunction: this.props.getFaqs,
              funcParams:[],
              url: data?.id? `faq/${data?.id}`: 'faq',
              _method:  data?.id? 'put':'post'
            }
          })
    }
    getAfterChange=()=>{
        this.props.getFaqs();
    }
  render() {
    const {faqs} = this.props;
    return (
        <div className='container  ml-auto mr-auto mt-10'>
        <div className='flex justify-between items-center'>
            <h2 className='text-xl text-blue-700 font-semibold'>Blog Page</h2>
            <Button title="Add Blog" onClick={this.editModalBtn.bind(this)} className=" bg-blue-700"  />
        </div>
        <div className='grid grid-cols-4 gap-10 mt-10'>
           {
            faqs?.map((data, i)=>{
                return(
                    <Card
                        image={data?.image_full_url}
                        key={i}
                        title={data?.title}
                        editBtnData={data}
                        editModalBtn={this.editModalBtn}
                        url={`faq/${data?.id}`}
                        getAfterChange={this.getAfterChange}
                    />
                )
            })
           }
           
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) =>({
    faqs: state.Data.faqs
});
const mapDispatchToProps = {getFaqs, changeStateValue}
export default connect(mapStateToProps, mapDispatchToProps)(FaqPage)

